import { SelectInputOption } from '@api/types';
import { TableInputRowData } from '@components/table-input/tableInput.types';
import React from 'react';

export type ValueType = SelectInputOption[] | number | boolean | string;

type QuestionAnswer = {
  [key: string]: ValueType | undefined; // TODO: fix types so that this is no longer needed
  questionId: number;
  answerYesNo?: boolean;
  answerDate?: string; // date?
  shortAnswerText?: string;
  fullAnswerText?: string;
  answerNumber?: number;
  hasJPAFileUploaded?: boolean;
  listValues?: string;
  formId?: number;
  questionTypeId?: number;
  answerId?: number;
};

export type ContactAnswer = {
  address: string;
  addressTwo?: string;
  city: string;
  company: string;
  contactType: string;
  country: string;
  emailAddress: string;
  faxCountryCode?: string;
  faxPhone?: string;
  firstName: string;
  contactAnswerId: number;
  lastName: string;
  middleName?: string;
  phoneOne: string;
  phoneOneCountryCode: string;
  phoneOneExtension?: string;
  phoneOneType: string;
  phoneTwo?: string;
  phoneTwoCountryCode?: string;
  phoneTwoExtension?: string;
  phoneTwoType?: string;
  questionId: number;
  requestAnswerSetId: number;
  salutation: string;
  state: string;
  zipcode: string;
};

export type FormAnswerSet = {
  [key: number]: QuestionAnswer;
};

export type InternalAnswerSet = {
  [key: number]: FormAnswerSet;
};

export type TableInputPageData = {
  // page number
  [key: string]: TableInputRowData[];
};

export type InternalTableAnswerSet = {
  // formId
  [key: string]: {
    // questionId
    [key: string]: TableInputPageData;
  };
};

export type TableAnswer = {
  questionId: number;
  dynRowNumber: number;
  dynColumnNumber: number;
  dynAnswerDate?: string;
  dynAnswerNumber?: number;
  dynAnswerYesNo?: number;
  dynListValues?: string;
  dynShortAnswerText?: string;
  questionTypeId?: number;
  requestAnswerSetId?: number;
  dynTableAnswerId?: number;
};

export type RequestAnswer = {
  answers: QuestionAnswer[];
  dynamicTableDeletedAnswers: number[];
  dynamicTableAnswers: TableAnswer[];
  contactAnswers: ContactAnswer[];
  formId: number;
  requestAnswerSetId: number;
  requestId: number;
  version: number;
};

type Request = {
  answerSetId: number;
  requestId: number;
  version: number;
};

export type RequestData = {
  [key: number]: Request;
};

export type Comparison = '=' | '!=' | 'contains' | 'exists' | 'compound';

export type EndCondition = {
  value: string | string[];
  comparison: Comparison;
  content: React.ReactNode;
  questionTypeId?: number;
};

export type QuestionList = {
  activeInd?: boolean;
  listId: number;
  listTitle?: string;
  questionId?: number;
  sortOrder?: number;
  valueDesc: string;
};

export type TriggerValue = string | string[] | number | boolean;

export type QuestionValue = string | number | boolean | string[] | null | undefined;

export type QuestionThreadParentBase = {
  comparison: Comparison;
  parentId: number;
  parentName: string;
  parentTypeId: number;
  triggerValue: TriggerValue;
};

export type QuestionThreadParent = QuestionThreadParentBase & {
  requiredQuestions?: QuestionThreadParentBase[];
  requiredQuestionThreads?: QuestionThreadParentBase[][];
};

export type ParentThreads = QuestionThreadParent[][];

export type QuestionData = {
  isRequired: boolean;
  questionId: number;
  questionTypeId: number;

  alertType?: 'info' | 'warning';
  allowsMultiselect?: boolean;
  clearQuestionIdsOnChange?: number[];
  contactType?: string | null;
  endConditions?: EndCondition[];
  helpInfo?: string;
  lists?: QuestionList[];
  options?: QuestionList[];
  parentQuestions?: QuestionThreadParent[];
  parentThreads?: ParentThreads;
  question?: string;
  questionName?: string;
  requireAllParents?: boolean;
  sectionId?: number;

  // show this functionality be refactored?
  showOptionalText?: boolean;
};

export type QuestionDataById = {
  [key: number]: QuestionData;
};

export type QuestionSectionData = {
  additionalInfo?: string;
  formId: number;
  isHeader?: boolean;
  questions?: QuestionData[];
  sectionId?: number;
  sectionName: string;
};

export type SectionDataById = {
  [key: number]: QuestionSectionData;
};

export const commonQuestionData = {
  allowsMultiselect: false,
  contactType: null,
  isRequired: true,
  showOptionalText: true,
  questionId: 0,
  questionName: '',
};

export type GetParentObject = (
  parentId: number,
  parentTypeId: number,
  comparison: Comparison,
  triggerValue: TriggerValue,
  requiredQuestions?: QuestionThreadParentBase[]
) => QuestionThreadParent;

export type QuestionNamesById = {
  [key: number]: string;
};

export type FormValues = {
  [key: number]: ValueType | undefined;
};
